/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Share_Invite_MessageInputs */

const en_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I’ve been using Forest to grow trees and stay focused, and it’s been working surprisingly well. Want to try it with me?

Use my invite code when you join Forest and you’ll get 300 free coins:

${i?.code}

[url]`)
};

const ar_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أستخدم Forest مؤخرًا لزراعة الأشجار والحفاظ على تركيزي، وكانت النتيجة أفضل مما توقعت. هل تريد تجربته معي؟

استخدم رمز الدعوة الخاص بي عند الانضمام إلى Forest لتحصل على 300 عملة مجانية:

${i?.code}

[url]`)
};

const de_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich nutze Forest, um Bäume wachsen zu lassen und konzentriert zu bleiben, und es funktioniert überraschend gut. Möchtest du es mit mir ausprobieren?

Nutze meinen Einladungscode, wenn du Forest beitrittst, und du erhältst 300 kostenlose Münzen:

${i?.code}

[url]`)
};

const es_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`He estado usando Forest para cultivar árboles y mantenerme concentrado, y me está funcionando sorprendentemente bien. ¿Quieres probarlo conmigo?

Usa mi código de invitación al unirte a Forest y recibirás 300 monedas gratis:

${i?.code}

[url]`)
};

const fr_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J’utilise Forest pour faire pousser des arbres et rester concentré, et ça marche étonnamment bien. Vous voulez essayer avec moi ?

Utilisez mon code d’invitation en rejoignant Forest pour obtenir 300 pièces gratuites :

${i?.code}

[url]`)
};

const it_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sto usando Forest per far crescere alberi e restare concentrato, e sta funzionando sorprendentemente bene. Vuoi provarlo con me?

Usa il mio codice invito quando ti unisci a Forest e riceverai 300 monete gratis:

${i?.code}

[url]`)
};

const ja_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最近、Forestで木を育てながら集中するのにハマっています。思った以上に効果があります！一緒に試してみませんか？

Forestを始めるときに私の招待コードを入力すると、無料で300コインを獲得できます：

${i?.code}

[url]`)
};

const ko_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`요즘 Forest로 나무를 키우며 집중하고 있는데, 생각보다 효과가 좋아요. 같이 해볼래요?

Forest를 시작할 때 제 초대 코드를 입력하면 무료 코인 300개를 받을 수 있어요:

${i?.code}

[url]`)
};

const pt_br_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tenho usado o Forest para cultivar árvores e manter o foco, e tem funcionado surpreendentemente bem. Quer experimentar comigo?

Use meu código de convite ao entrar no Forest e ganhe 300 moedas grátis:

${i?.code}

[url]`)
};

const ru_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Я пользуюсь Forest, чтобы выращивать деревья и сохранять концентрацию, и это работает на удивление хорошо. Хочешь попробовать вместе со мной?

Используй мой код приглашения при регистрации в Forest и получи 300 бесплатных монет:

${i?.code}

[url]`)
};

const th_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ช่วงนี้ฉันใช้ Forest ปลูกต้นไม้และช่วยให้ตัวเองมีสมาธิ ซึ่งได้ผลดีเกินคาดเลย อยากลองด้วยกันไหม?

ใช้รหัสเชิญของฉันตอนเข้าร่วม Forest แล้วคุณจะได้รับ 300 เหรียญฟรี:

${i?.code}

[url]`)
};

const tr_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forest’i ağaç yetiştirmek ve odaklanmak için kullanıyorum, beklediğimden çok daha iyi işe yarıyor. Benimle denemek ister misin?

Forest’e katılırken davet kodumu kullan, 300 ücretsiz jeton kazan:

${i?.code}

[url]`)
};

const zh_cn_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我最近迷上用 Forest 种树让自己更专注，效果意外地好！你也可以试试看。

输入我的邀请码即可获得 300 金币：

${i?.code}

[url]`)
};

const zh_tw_share_invite_message = /** @type {(inputs: Share_Invite_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我最近迷上用 Forest 種樹讓自己更專注，效果意外地好！你也可以試試看。

輸入我的邀請碼即可獲得 300 金幣：

${i?.code}

[url]`)
};

/**
* | output |
* | --- |
* | "I’ve been using Forest to grow trees and stay focused, and it’s been working surprisingly well. Want to try it with me? Use my invite code when you join Fore..." |
*
* @param {Share_Invite_MessageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const share_invite_message = /** @type {((inputs: Share_Invite_MessageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Invite_MessageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_invite_message(inputs)
	if (locale === "ar") return ar_share_invite_message(inputs)
	if (locale === "de") return de_share_invite_message(inputs)
	if (locale === "es") return es_share_invite_message(inputs)
	if (locale === "fr") return fr_share_invite_message(inputs)
	if (locale === "it") return it_share_invite_message(inputs)
	if (locale === "ja") return ja_share_invite_message(inputs)
	if (locale === "ko") return ko_share_invite_message(inputs)
	if (locale === "pt_br") return pt_br_share_invite_message(inputs)
	if (locale === "ru") return ru_share_invite_message(inputs)
	if (locale === "th") return th_share_invite_message(inputs)
	if (locale === "tr") return tr_share_invite_message(inputs)
	if (locale === "zh_cn") return zh_cn_share_invite_message(inputs)
	return zh_tw_share_invite_message(inputs)
});